import { render, staticRenderFns } from "./BackgroundActionItem.vue?vue&type=template&id=218865c8&scoped=true"
import script from "./BackgroundActionItem.vue?vue&type=script&lang=js"
export * from "./BackgroundActionItem.vue?vue&type=script&lang=js"
import style0 from "./BackgroundActionItem.vue?vue&type=style&index=0&id=218865c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218865c8",
  null
  
)

export default component.exports